module.exports = __webpack_public_path__ + "static/media/about-helper.3687bf86.png";